import { render, staticRenderFns } from "./EnacProcedureAtpDafEditSaveSubmit.vue?vue&type=template&id=15b47e67"
import script from "./EnacProcedureAtpDafEditSaveSubmit.vue?vue&type=script&lang=js"
export * from "./EnacProcedureAtpDafEditSaveSubmit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports